import { Attributes, Rules, Validation } from '@singularsystems/neo-core';
import TemporalEntity from "../../TemporalEntity";

export default class Title extends TemporalEntity {
    static typeName = "Title";

    constructor() {
        super();
        this.makeObservable();
    }

    public titleId: number = 0;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Title")
    public titleName: string = "";

    @Rules.StringLength(20)
    public pronoun: string | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.titleName) {
            return "New title";
        } else {
            return this.titleName;
        }
    }
}